module.exports = __webpack_public_path__ + "static/media/Blue.07b0dc1f.png";